import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-impact-details',
  templateUrl: './impact-details.component.html',
  styleUrl: './impact-details.component.scss',
})
export class ImpactDetailsComponent extends BaseComponent {
  @Input() familyName = '';
  @Input() impact = 0; // 0-100;
  @Input() iconName = '';
  @Input() isLoading: boolean = true;

  constructor(public motivationService: AbstractMotivationsService) {
    super();
  }

  ngOnInit(): void {
   super.ngOnInit();
  }

  getMotivationIconName(motivationId: string): string {
    return this.motivationService.getMotivationIconName(motivationId);
  }

  getMotivationName(motivationId: string): string {
    return this.motivationService.getMotivationName(motivationId);
  }
}
